// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import VueProgressBar from 'vue-progressbar'
import VueLocalStorage from 'vue-ls'
import Notifications from 'vue-notification'
import store from './store'

Vue.use(Notifications)
Vue.use(VueLocalStorage)

Vue.use(VueProgressBar, {
  color: 'rgb(143, 255, 199)',
  failedColor: 'red',
  height: '2px'
})

Vue.use(VueRouter)
Vue.use(VueResource)

Vue.http.options.root = process.env.API_URL

Vue.http.interceptors.push((request, next) => {
  const token = Vue.ls.get('token', 'unauth')
  if (token !== 'unauth') {
    request.headers.set('Authorization', 'Bearer ' + token)
  } else {
    console.log('NO token')
  }
  request.headers.set('X-B2N', 'yes')
  next()
})

Vue.use(BootstrapVue)
Vue.router = router

Vue.prototype.$eventHub = new Vue()

/* eslint-disable no-new */
export var vue = new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  },
  mounted: function () {
    this.$eventHub.$on('redirectToLogin', this.redirectToLogin)
  },
  beforeDestroy: function () {
    this.$eventHub.$off('redirectToLogin')
  },
  methods: {
    redirectToLogin () {
      this.$ls.remove('token')
      store.commit('LOGOUT_USER')
      router.go({name: 'login'})
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js